
import './App.css';
import Dictionary from "./Dictionary.js";

function App() {
  return (
    <div className="App">
      <div className="container">
      <header className="App-header"> 
      
      </header>
      <main>
        <Dictionary defaultKeyword="sunset"/> 
      </main>
      <footer className="App-footer">

       <small>Coded by <a href= "github.com/nellyobi"> Nelly Obi </a> and is <a href="github.com/nellyobi/dictionary-project"> open-sourced </a>  on Github.</small> 
      </footer>
      </div>
    </div>
  );
}

export default App;
